<main class="w-100 h-100 ">

    <!-- فرم ورود کاربران -->

    <section class="login-container py-md-5 py-0" [ngStyle]="{'height':!isLandingWithLogin ? '100vh' : ''}">

        <div class="d-flex justify-content-center align-items-center p-3 pmd-0" style="max-width: 100vw;">

            <div class="myContainer" id="myContainer">

                <div class="form-container sign-up-container">

                    <form [formGroup]="RegisterModel" class="dirI form" *ngIf="!otp">

                        <img src="../../../assets/Img/fleetYar_logo.png" class="logo my-1">

                        <h4 class="bold">ثبت نام</h4>

                        <input class="dirI input" type="text " formControlName="strUserName" type="tel" placeholder="شماره موبایل" value="" />

                        <input class="input" formControlName="strFullName" type="text" placeholder="نام کامل" value="" onfocus="this.removeAttribute('readonly');" readonly />

                        <input class="input" type="password" autocomplete="new-password" formControlName="strPassword" id="password" placeholder="رمز عبور مد نظر" />

                        <input class="input" type="password" formControlName="strPassword2" autocomplete="off"  placeholder="تکرار رمز عبور مد نظر" />

                        <input class="dirI input" type="tel" formControlName="strIntroducedMobile"placeholder="شماره موبایل معرف" value="" />

                        <button class="button" (click)="register()">ثبت نام</button>

                    </form>

                    <form *ngIf="otp" [formGroup]="OtpModel" class=" form">
                        <input class="dirI input" type="tel" formControlName="iOTP" placeholder="کد دریافتی" value="" />
                        <a class="a pointer" (click)="createOtp(true)" *ngIf="!repet">ارسال مجدد کد</a>
                        <p class="p" *ngIf="repet">{{timeLeft}} </p>

                        <button class="button" (click)="chekOtp()">بررسی کد</button>

                    </form>

                </div>

                <div class="form-container sign-in-container">
                    <form class="dirI form" [formGroup]="LoginModel">
                        <img src="../../../assets/Img/fleetYar_logo.png" class="logo mt-2 mb-2">
                        <h4 class="bold">ورود</h4>
                        <input class=" input" type="text" formControlName="strUserName" name="usreName"
                            placeholder="نام کاربری" autocomplete="off" />
                        <input class=" input" type="password" placeholder="کلمه عبور" autocomplete="new-password"
                            formControlName="strPassword" name="password" />

                        <div class="captcha-area col-12">

                            <button type="button" tabindex="-1" class="reload-btn" (click)="get_Captcha()">

                                <i class="fa fa-refresh" aria-hidden="true"></i>

                            </button>

                            <div class="captcha-img">

                                <img src="../../../assets/Img/captcha-bg.png" alt="">

                                <span class="captcha">{{captcha}}</span>

                            </div>
                        </div>



                        <input class="input text-center" id="_captcha" type="tel" name="captcha"
                            formControlName="strCaptcha" #_captcha required placeholder="کد امنیتی"
                            [maxlength]="captcha.toString().length" (keypress)="numberOnly($event)" />

                        <button class="button" (click)="Login()">ورود</button>
                        <a class="pointer mt-2" (click)="ForgetPass()">رمز عبور را فراموش کردید؟</a>
                    </form>
                </div>

                <div class="overlay-container">

                    <div class="overlay">

                        <div class="overlay-panel overlay-left">

                            <h2>قبلا ثبت نام کردید؟</h2>

                            <p class="p">برای ورود به سامانه کلیک کنید</p>

                            <button class="ghost button" id="signIn" (click)="signIn()">ورود</button>

                            <div class="d-flex justify-content-center flex-column align-items-center mb-4 pointer"
                                (click)="getLink(1)">

                                <a class="text-white ms-2 a"> راهنمای برنامه</a>

                                <div class="row mt-5">
                                    <a class="text-decoration-none text-white" href="">{{appName}}</a>
                                    <span>{{version | faNum}}</span>
                                </div>
                            </div>

                        </div>

                        <div class="overlay-panel overlay-right">

                            <h1 class="dirI h1"> {{ webAppName }} </h1>

                            <p class="p">اطلاعات خود را وارد کنید و به سامانه {{ webAppName }} بپیوندید</p>

                            <button class="ghost button" id="signUp" *ngIf="false" (click)="signUp()">ثبت نام</button>

                            <div class="d-flex justify-content-center flex-column align-items-center mb-4 pointer">

                                <a class="text-white m-2" href="http://fleetYar.com" target="_blank"> راهنمای برنامه </a>

                                <div class="row mt-5">

                                    <a class="text-decoration-none text-white" href="">{{appName}}</a>

                                    <span>{{version | faNum}}</span>

                                </div>

                            </div>

                        </div>
                    </div>

                </div>

            </div>

        </div>

    </section>

    <ng-container *ngIf="isLandingWithLogin">

        <!--  مدیریت ناوگان، تعمیر و نگهداری و سرویس های دوره ای خودرو و موتورسیکلت  -->

        <section class="">

            <div class="py-5 d-flex flex-column justify-content-center align-items-center">

                <div class="img-container text-center">

                    <img width="128px" src="../../assets/Img/car-office.png" alt=" مدیریت ناوگان، تعمیر  و نگهداری و سرویس های دوره ای خودرو و موتورسیکلت ">

                </div>

                <h1 class="fw-bold mt-3 text-center" style="font-size: 25px;line-height: 40px;"> 
                
                    <p class="mb-1"> <strong> {{ webAppName }} </strong> </p>

                    مدیریت ناوگان، تعمیر  و نگهداری و سرویس های دوره ای خودرو و موتورسیکلت

                </h1>

                <div class="title-header w-100">

                    <p class="m-0 text-muted text-center p-md-5" style="font-size:16px;line-height: 40px;">

                        با {{webAppName}}، ناوگان خود را به‌صورت هوشمند مدیریت کنید! این نرم‌افزار با امکاناتی مانند اتوماسیون سفرهای اداری، برنامه‌ریزی سرویس‌های دوره‌ای، ردیابی وضعیت تانکرها و پایش مایعات داخل آن‌ها، به شما کمک می‌کند تا هزینه‌ها را کاهش دهید و بهره‌وری را افزایش دهید. نسخه وب و موبایل {{webAppName}}، مدیریت ناوگان را در هر زمان و هر مکان برای شما آسان می‌کند

                    </p>

                </div>

            </div>

        </section>

        <!-- آگهی های مرتبط با خرید، فروش، اجاره انواع خودرو، موتور سیکلت و راننده -->

        <section *ngIf="false" class="marketers my-5 row gx-0 gy-0" #adsContainer>

            <div class="col-md-12 my-4 central">

                <div class="container text-center">

                    <div class="img-container text-center my-4">

                        <img width="128px" src="../../../assets/Img/ads.png" alt="آگهی های آماده به کار،استخدام راننده">

                    </div>

                    <h2 class="fw-bold"> آگهی های مرتبط با خرید، فروش، اجاره انواع خودرو، موتور سیکلت و راننده </h2>

                    <p style="line-height: 40px;font-size: 15px;">

                        .در این بخش از {{ webAppName }}، آگهی مرتبط با جرثقیل ثابت و سیار و خدمات مرتبط ارائه می گردد

                    </p>

                    <ng-container *ngIf="lst_NewAds.length > 0">

                        <owl-carousel-o [options]="carouselOptions4News">

                            <ng-template *ngFor="let item of lst_NewAds" carouselSlide>

                                <div class="p-2 h-100" (click)="showAds(item)">

                                    <div class="adds_box border border-2 h-100 p-1">

                                        <div class="img_box">

                                            <img src="{{item.strImage != '' ? 'data:image/png;base64,' + item.strImage : '../../../assets/Img/preview__thumbnail.png'}}" [title]="item.strTitle" alt="{{item.strTitle}}">

                                        </div>

                                        <div class="detail_box w-100 h-100" style="max-height: 80px!important;">

                                            <h3 class="fw-bold mx-0 mb-1 text-start" style="font-size: 13px;">

                                                {{ subString_Title(item.strTitle,24) | faNum}}
                                            
                                            </h3>

                                            <div class="text-start">

                                                <span class="text-muted" style="font-size: 13px;">

                                                    {{ item.strPublishTime }} در {{ item.strCityName }}

                                                </span>

                                            </div>

                                        </div>

                                    </div>

                                </div>

                            </ng-template>

                        </owl-carousel-o>

                    </ng-container>

                    <button class="btn btn-primary px-5 my-2 ">

                        <a class="text-white" href="jobs" target="_blank">

                            مشاهده آگهی&zwnj;ها

                        </a>

                    </button>

                </div>

            </div>

        </section>

        <!-- اخبار،اطلاعات و نکات ایمنی در خصوص خودرو و ردیاب  -->

        <section [ngClass]="news.length > 0 ? 'py-3' : ''" #EventContainer>

            <div class="container">

                <ng-container *ngIf="news.length > 0">

                    <div class="central sec_title my-5">

                        <h3> اخبار،اطلاعات و نکات ایمنی در خصوص خودرو و ردیاب  </h3>

                    </div>

                    <owl-carousel-o [options]="carouselOptions4News">

                        <ng-template *ngFor="let item of news" carouselSlide>

                            <div (click)="openNews(item?.iNews)" class="p-2 h-100 border border-2 rounded pointer">

                                <div class="adds_box h-100">

                                    <div class="img_box">

                                        <img *ngIf="item.strImage" src="data:image/png;base64,{{item.strImage}}" [title]="item.strTitle" alt="{{item.strTitle}}">

                                        <img *ngIf="!item.strImage" src="../../../assets/imgs/preview__thumbnail.png" alt="{{item.strTitle}}">

                                    </div>

                                    <div class="detail_box w-100 h-100" style="max-height: 70px!important;">

                                        <h3 class=" fw-bold mx-0 mb-1" style="font-size: 13px;"> 
                                            
                                            {{ subString_Title(item.strTitle,35) | faNum }} 
                                        
                                        </h3>

                                        <div class="text-start">

                                            <span class="text-muted" style="font-size: 13px;">
                                                
                                                {{ item.strValidateDateAndTime }}
                                            
                                            </span>

                                        </div>

                                    </div>

                                </div>

                            </div>

                        </ng-template>

                    </owl-carousel-o>

                    <div class="central">

                        <button class="btn btn-primary btn-title my-3 ">

                            <a class="text-white" href="/news" target="_blank"> مشاهده بیشتر </a>

                        </button>

                    </div>

                </ng-container>

            </div>


        </section>

        <!-- فیلم های آموزشی مرتبط با ردیاب، خودرو و موتورسیکلت  -->

        <section [ngClass]="news.length > 0 ? 'p-3 my-5' : ''" #EducationContainer>

            <article class="container">

                <div class="row gx-0 gy-2">

                    <div class="central sec_title my-5">

                        <h3> فیلم های آموزشی مرتبط با ردیاب، خودرو و موتورسیکلت  </h3>

                    </div>

                    <owl-carousel-o [options]="carouselOptions4News">

                        <ng-template *ngFor="let item of lst_Educations" class="col-md-4 col-12 p-3 " carouselSlide>

                            <div class="card w-100 pointer" (click)="openEducation(item)">

                                <div class="video-container">
        
                                    <iframe class="responsive-iframe"
                                    
                                        [src]="item.strContentPath" 
                                    
                                        allowFullScreen="true" 
                                        
                                        webkitallowfullscreen="true" 
                                        
                                        mozallowfullscreen="true">
                                    
                                    </iframe>       
        
                                </div>
        
                                <div class="card-body">
        
                                    <h4 class="card-title mb-1" style="height:51px;font-size: 15px;line-height: 23px;">  
                                        
                                        {{ subString_Title(item.strTitle,63) | faNum }} 
                                    
                                    </h4>

                                    <p class="card-text text-muted" style="height: 70px;font-size: 12px;"> 
                                        
                                        {{ subString_Title(item.strDetail,130) | faNum}}
                                    
                                    </p>
        
                                </div>
        
                            </div>

                        </ng-template>

                    </owl-carousel-o>

                    <div class="central">

                        <button class="btn btn-primary btn-title my-3 ">

                            <a class="text-white" href="/educations" target="_blank"> مشاهده بیشتر </a>

                        </button>

                    </div>

                </div>

            </article>

        </section>

        <!-- فوتر -->

        <section class="footer p-2">

            <div class="px-md-5 px-2">

                <div class="row gx-0 gy-0">

                    <!-- درباره ما -->
        
                    <div class="col-md-3">

                        <div class="">

                            <h4>درباره ما</h4>
        
                            <p style="line-height: 30px;font-size: 15px;font-weight: normal;" class="text-white my-3">
                                
                               {{ webAppName }}

                                راهکاری یکپارچه برای مدیریت ناوگان، سرویس‌ های دوره ‌ای، تعمیرات، سفرهای اداری، نظارت بر تانکرها و پایش مایعات. با {{webAppName}}، بهره‌وری را افزایش دهید و هزینه‌ها را کاهش دهید.

                            </p>

                        </div>

                    </div>

                    <!-- لینک های مفید -->

                    <div class="col-md-3">

                        <div class="">

                            <h4 class="text-center"> لینک های مفید</h4>
        
                            <ul class="linksuse">
        
                                <li class="">
        
                                    <a class="text-white" href="https://rayanandisheh.com" target="_blank">
        
                                        شرکت مهندسی رایان اندیشه نصر 
        
                                    </a>
        
                                
                                </li>
        
                                <li class="">
        
                                    <a class="text-white" href="https://emdadran.ir" target="_blank">
        
                                        درخواست جرثقیل سیار و امداد   
        
                                    </a>
        
                                
                                </li>
                                
                                <li class="">
        
                                    <a class="text-white" href="https://taxilon.ir" target="_blank">
        
                                        درخواست تاکسی بین شهری 
        
                                    </a>
        
                                
                                </li>
                                
                                <li class="">
        
                                    <a class="text-white" href="https://shahrnik.com" target="_blank">
        
                                        ارتباط مردمی و 137 شهرداری
        
                                    </a>
        
                                
                                </li>
                                
                                <li class="">
        
                                    <a class="text-white" href="https://didarba.ir" target="_blank">
        
                                        مدیریت جلسات و موصوبات 
        
                                    </a>
        
                                
                                </li>
                                
                                <li class="">
        
                                    <a class="text-white" href="https://madonik.ir" target="_blank">
        
                                        مدرسه الکترونیک 
        
                                    </a>
        
                                
                                </li>
        
                            </ul>
        
                        </div>

                    </div>

                    <!-- راه های ارتباطی -->

                    <div class="col-md-3">

                        <div>

                            <h4 class="text-center"> راه های ارتباطی </h4>
        
                            <ul class="linksuse">

                                <li>
                                    {{' ایمیل: rayanandisheh@yahoo.com'}}
        
                                </li>
        
                                <li class="d-flex">

                                    <span>تلفن:</span>

                                    <span class="d-flex mx-1">

                                        {{ '  021-77273160-2' | faNum   }}

                                    </span>

                                </li>

                                <li>
        
                                    آدرس شرکت : {{ 'تهران، نارمک بزرگراه شهید سلیمانی بعد از چهارراه سرسبز پلاک 640 واحد 8' | faNum }}
        
                                </li>

                            </ul>

                        </div>

                    </div>

                    <!-- مارا دنبال کنید -->

                    <div class="col-md-3">

                        <div class="">

                            <h4 class="text-center"> مارا دنبال کنید </h4>
        
                            <div class=" social">
        
                                <div class="d-nones links">

                                    <img src="../../../assets/Img/fleetYar_logo_only.png" [alt]="webAppName">

                                <a href="https://cafebazaar.ir/app/com.rayanandisheh.radyab" target="_blank" class="pointer">

                                        <img src="../../../assets/Img/bazaar_prev_ui.png" [alt]="'دانلود' + ' ' + webAppName">

                                </a>
        
                                </div>
        
                                <div class="social1 d-flex justify-content-center pt-2">
        
                                    <a target="_blank" href="https://www.instagram.com/{{obj_Social.strIG}}">
        
                                        <i class="fa fa-instagram pointer" aria-hidden="true"></i>
        
                                    </a>
        
                                    <a target="_blank" href="mailto:{{obj_Social?.strEmail}}">
        
                                        <i class="fa fa-envelope-o" aria-hidden="true"></i>
        
                                    </a>
        
                                </div>
        
                            </div>
        
                        </div>
        
                    </div>
        
                </div>
        
            </div>

        </section>

    </ng-container>

</main>